import React from 'react';
import { createRoot } from 'react-dom/client';
import { Button, Icon } from '@ok/okd';
import { toLocale } from '@common/i18n';
import { withOkg } from '@ok/okg';
import { date, okGlobal } from '@ok/blade';
import { getImages } from '@common/utils/CoinIcons';
import DatePicker from 'react-datepicker';
import { ja, zhCN, enUS } from 'date-fns/locale';
import Table from './Table';
import 'react-datepicker/dist/react-datepicker.css';

import './index.less';

const popperModifiers = {
  name: 'preventOverflow',
  options: {
    boundariesElement: 'viewport',
  },
  boundaries: {},
};

const LANGUAGE_MAP = {
  ja_JP: ja,
  zh_CN: zhCN,
  en_US: enUS,
};

class BtcIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: date.subtract(7, 'd', date.set({ h: 0, m: 0, s: 0 })),
      endDate: date.subtract(1, 'd', date.set({ h: 23, m: 59, s: 59 })),
    };
  }

  getStartMinDate = () => {
    return date.set({ y: 2023, M: 5, d: 1, h: 0, m: 0, s: 0 });
  };

  getStartMaxDate = () => {
    return new Date() < this.state.endDate ? new Date() : this.state.endDate;
  };

  getEndMinDate = () => {
    return this.state.startDate;
  };

  getEndMaxDate = () => {
    return new Date() > this.state.endDate ? new Date() : this.state.endDate;
  };

  onStartDateChanged = (startDate) => {
    this.setState({
      startDate: date.set({
        y: startDate.getFullYear(),
        M: startDate.getMonth() + 1,
        d: startDate.getDate(),
        h: 0,
        m: 0,
        s: 0,
      }),
    });
  };

  onEndDateChanged = (endDate) => {
    this.setState({
      endDate: date.set({
        y: endDate.getFullYear(),
        M: endDate.getMonth() + 1,
        d: endDate.getDate(),
        h: 23,
        m: 59,
        s: 59,
      }),
    });
  };

  // 8->08  9->09
  formatMonth = (month) => `${month < 9 ? '0' : ''}${month + 1}`;

  formatDay = (day) => `${day < 10 ? '0' : ''}${day}`;

  downloadCsvFile = () => {
    const { startDate, endDate } = this.state;
    const paramsStartDate = `${startDate.getFullYear()}-${this.formatMonth(
      startDate.getMonth()
    )}-${this.formatDay(startDate.getDate())}`;
    const paramsEndDate = `${endDate.getFullYear()}-${this.formatMonth(
      endDate.getMonth()
    )}-${this.formatDay(endDate.getDate())}`;

    window.seoMonitor.act('web_btc_index_download_click');
    window.open(
      `/v2/support/home/price-index/btc_jpy/download?startDate=${paramsStartDate}&endDate=${paramsEndDate}&pageNum=0&pageSize=1`
    );
  };

  UNSAFE_componentWillMount() {
    window.seoMonitor.act('web_btc_index_exposure');
  }

  render() {
    const { isSm } = this.props;
    const { startDate, endDate } = this.state;
    const srcImg = getImages('btcIndex/btc_index');

    return (
      <div className="btc-index-box">
        <div className="btc-index-title">
          <div className="title-left">
            <div className="top">OKJ BTC Index</div>
            <div className="bottom">{toLocale('btc_index_top_subtitle')}</div>
          </div>
          <div className="title-right">
            <div className="title-inner">
              <img src={srcImg} alt="" />
            </div>
          </div>
        </div>
        <div className="content">
          <div className="content-background" />
          <Table />
          <div className="table">
            <li className="table-tip">{toLocale('btc_index_tip1')}</li>
            <li className="table-tip">{toLocale('btc_index_tip2')}</li>
            <li className="table-tip">{toLocale('btc_index_tip3')}</li>
          </div>
          <div className="download-title">
            {toLocale('btc_index_download_csv_title')}
          </div>
          <div className="range-picker-wrapper">
            <div className="range-picker">
              <DatePicker
                fixedHeight
                selected={startDate}
                onChange={this.onStartDateChanged}
                minDate={this.getStartMinDate()}
                maxDate={this.getStartMaxDate()}
                dateFormat="yyyy-MM-dd"
                dateFormatCalendar="yyyy MMMM"
                className="data-picker-container"
                autocomplete="off"
                locale={LANGUAGE_MAP[okGlobal.locale]}
                popperModifiers={popperModifiers}
              />
              <Icon className="okds-arrow-pointer-right-md" />
              <DatePicker
                fixedHeight
                selected={endDate}
                minDate={this.getEndMinDate()}
                maxDate={this.getEndMaxDate()}
                onChange={this.onEndDateChanged}
                dateFormat="yyyy-MM-dd"
                dateFormatCalendar="yyyy MMMM"
                className="data-picker-container"
                autocomplete="off"
                locale={LANGUAGE_MAP[okGlobal.locale]}
                popperModifiers={popperModifiers}
              />
              <div className="picker-icon">
                <i className="icon iconfont okds-calendar" />
              </div>
            </div>
            <div className="button-container">
              <Button
                category={Button.CATEGORY.fill}
                type={Button.TYPE.primary}
                size={Button.SIZE.lg}
                onClick={this.downloadCsvFile}
              >
                {toLocale('btc_index_download_csv_file')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const BtcIndexWithOkg = withOkg(BtcIndex);
const root = createRoot(document.getElementById('root'));
root.render(<BtcIndexWithOkg />);
